import {Attribute} from '../../../components/ObjectAttribute';
import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const searchShipmentsRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/shipments',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/shipments' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const searchShipmentsResponse: Json = {
    title: 'RESPONSE',
    json: {
        'totalCount': 2,
        'totalPages': 1,
        'pageNumber': 1,
        'pageSize': 100,
        'results': [
            {
                'id': 1,
                'shipNumber': '1',
                'orderNumber': '10001',
                'orderType': 'SO',
                'shipTo': 'John Smith',
                'shipToOrderNumber': 'CUST-PO-001',
                'carrier': 'FedEx',
                'carrierService': 'Ground',
                'dateShipped': '2026-01-15T10:30:00Z',
                'dateScheduled': '2026-01-14T00:00:00Z',
                'status': 'Shipped'
            },
            {
                'id': 2,
                'shipNumber': '2',
                'orderNumber': '10002',
                'orderType': 'SO',
                'shipTo': 'Jane Doe',
                'shipToOrderNumber': '',
                'carrier': 'UPS',
                'carrierService': 'Next Day Air',
                'dateShipped': null,
                'dateScheduled': '2026-01-20T00:00:00Z',
                'status': 'Entered'
            }
        ]
    },
};

const searchShipmentsQueryParameters: Attribute[] = [
    {
        name: 'pageNumber',
        type: 'integer',
        optional: true,
        description: 'The current page of the results.'
    },
    {
        name: 'pageSize',
        type: 'integer',
        optional: true,
        description: 'The number of returned results per page. (Default 100)'
    },
    {
        name: 'orderNumber',
        type: 'string',
        optional: true,
        description: 'Filter by order number.',
    },
    {
        name: 'shipNumber',
        type: 'string',
        optional: true,
        description: 'Filter by shipment number.',
    },
    {
        name: 'orderType',
        type: 'string: \'SO\' | \'PO\' | \'TO\'',
        optional: true,
        description: 'Filter by order type.',
    },
    {
        name: 'shipToOrderNumber',
        type: 'string',
        optional: true,
        description: 'Filter by ship-to order number (Customer PO or Vendor SO).',
    },
    {
        name: 'status',
        type: 'string: \'All\' | \'All Open\' | \'Entered\' | \'Packed\' | \'Shipped\'',
        optional: true,
        description: 'Filter by shipment status.',
    },
    {
        name: 'locationGroup',
        type: 'string',
        optional: true,
        description: 'Filter by location group name.',
    },
    {
        name: 'carrier',
        type: 'string',
        optional: true,
        description: 'Filter by carrier name.',
    },
    {
        name: 'carrierServiceId',
        type: 'integer',
        optional: true,
        description: 'Filter by carrier service ID.',
    },
    {
        name: 'customerName',
        type: 'string',
        optional: true,
        description: 'Filter by customer name.',
    },
    {
        name: 'trackingNumber',
        type: 'string',
        optional: true,
        description: 'Filter by tracking number.',
    },
    {
        name: 'shipDateFrom',
        type: 'string (yyyy-MM-dd)',
        optional: true,
        description: 'Filter by ship date range start.',
    },
    {
        name: 'shipDateTo',
        type: 'string (yyyy-MM-dd)',
        optional: true,
        description: 'Filter by ship date range end.',
    },
    {
        name: 'scheduleDateFrom',
        type: 'string (yyyy-MM-dd)',
        optional: true,
        description: 'Filter by schedule date range start.',
    },
    {
        name: 'scheduleDateTo',
        type: 'string (yyyy-MM-dd)',
        optional: true,
        description: 'Filter by schedule date range end.',
    },
    {
        name: 'productNumber',
        type: 'string',
        optional: true,
        description: 'Filter by product number.',
    },
    {
        name: 'productDescription',
        type: 'string',
        optional: true,
        description: 'Filter by product description.',
    },
    {
        name: 'partNumber',
        type: 'string',
        optional: true,
        description: 'Filter by part number.',
    },
    {
        name: 'partDescription',
        type: 'string',
        optional: true,
        description: 'Filter by part description.',
    },
];

const searchShipmentsAttributes: Attribute[] = [
    {
        name: 'customFields',
        type: 'list',
        description: 'A list of custom fields to filter by.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identifier for the custom field.',
            },
            {
                name: 'value',
                type: 'string',
                description: 'The custom field\'s value.'
            },
        ]
    }
];

const data: RequestDefinitionData = {
    id: 'search-shipments',
    title: 'Search for shipments',
    description: 'Searches for shipments. Requires SHIP_VIEW access right.',
    endpoint: {
        verb: 'GET',
        path: '/shipments',
        tooltip: 'Search for shipments',
    },
    attributes: searchShipmentsAttributes,
    requestObject: searchShipmentsRequest,
    responseObject: searchShipmentsResponse,
    queryParameters: searchShipmentsQueryParameters,
}

export default data;
